module.exports = __webpack_public_path__ + "src/assets/img/light_stop.ef968ead.svg";